export const CreditCardCardComponent = {
    bindings: {
        card: '<',
        delete: '<'
    },
    template: `
        <div class="card-label">
            <span c-type="body-md-primary bold">{{$ctrl.formattedCard.cardBrand}}</span>
            <span c-type="body-sm-secondary light" class="primary-tag" ng-if="$ctrl.formattedCard.isPrimary">Primary</span>
        </div>
        <p c-type="title-sm-primary">{{$ctrl.formattedCard.maskedPan}}</p>
        <p c-type="title-sm-primary">Exp. {{$ctrl.formattedCard.expirationMonth}}/{{$ctrl.formattedCard.expirationYear}}</p>
    `,
    controller: class {
        constructor(paymentService) {
            'ngInject';
            this.paymentService = paymentService;
        }
        $postLink() {
            if(!this.card) {
                this.card = {
                    accountName: 'INVALID',
                    maskedPan: 'XXXX-XXXX-XXXX-1234',
                    expirationMonth: '00',
                    expirationYear: '00',
                    cardBrand: 'Unknown',
                    isPrimary: false,
                    guid: 'asdfj230942348092isdlkfj23'
                };
            }
            this.formattedCard = this.paymentService.getFormattedCreditCard(this.card);
        }
    }
};
